import { render, staticRenderFns } from "./IapProducts.vue?vue&type=template&id=7c647164&"
import script from "./IapProducts.vue?vue&type=script&lang=js&"
export * from "./IapProducts.vue?vue&type=script&lang=js&"
import style0 from "./IapProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports